// Copyright (c) 2016 Deere & Company

import NormalClaimContainer from '../../claim/normal/state-connector';

export default {
    component: NormalClaimContainer,
    name: 'NORMAL',
    path: 'normal/edit/:claimNumber'
};



// WEBPACK FOOTER //
// ./src/routes/claims/edit-normal-claim-route.js